<template>
  <svg
    id="Admin"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 241.259 204.297"
  >
    <g
      id="Retângulo_10"
      data-name="Retângulo 10"
      transform="translate(0 28.297)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <path
      id="Caminho_4"
      data-name="Caminho 4"
      d="M0-12H169.377l-7.794,117.077H0Z"
      transform="translate(82.748 169.377) rotate(-90)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-user-lock"
      data-name="Icon awesome-user-lock"
      d="M65.584,74.953A37.477,37.477,0,1,0,28.108,37.477,37.477,37.477,0,0,0,65.584,74.953ZM93.692,93.692a18.469,18.469,0,0,1,2.372-8.93,40.067,40.067,0,0,0-4.245-.439h-4.89a50.968,50.968,0,0,1-42.688,0h-4.89A39.357,39.357,0,0,0,0,123.664v12.189a14.054,14.054,0,0,0,14.054,14.054H96.3a18.6,18.6,0,0,1-2.606-9.369Zm84.323-9.369h-9.369V60.9a23.423,23.423,0,0,0-46.846,0V84.323H112.43a9.369,9.369,0,0,0-9.369,9.369v46.846a9.369,9.369,0,0,0,9.369,9.369h65.584a9.369,9.369,0,0,0,9.369-9.369V93.692A9.369,9.369,0,0,0,178.014,84.323Zm-32.792,42.161a9.369,9.369,0,1,1,9.369-9.369A9.369,9.369,0,0,1,145.222,126.484Zm9.369-42.161H135.853V60.9a9.369,9.369,0,0,1,18.738,0Z"
      transform="translate(53.875 8.89)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
